// extracted by mini-css-extract-plugin
module.exports = {"container":"CategoryPreviewSubCategoryList_container__Ntdhd","list-container":"CategoryPreviewSubCategoryList_list-container__SihTZ"};